module.exports = __webpack_public_path__ + "img/kvbackground.093e9bc0.png";